import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientCarePlanControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  patientUuid: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: boolean;
  archive?: boolean;
  current?: boolean;
  appointmentUuid?: string;
  searchString?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientCarePlanList = ({
  patientUuid,
  pagination,
  gridSorting,
  status,
  archive,
  current,
  appointmentUuid,
  searchString,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "patient-careplan-list",
      patientUuid,
      pageIndex,
      pageSize,
      gridSorting,
      sortData,
      status,
      archive,
      current,
      searchString,
      xTENANTID,
      sortData,
    ],
    enabled: enabled,
    refetchOnWindowFocus: false,

    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientCarePlanControllerApi(getConfigObject())
        .getCarePlans(
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined,
          status,
          archive,
          current,
          patientUuid,
          appointmentUuid,
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
